import React from 'react';
import Form from 'react-bootstrap/esm/Form';
import { useDispatch, useSelector } from 'react-redux';
import { IReducer } from '../../../../../../../../../redux/configureStore';
import { setCodLeg } from '../../../../../../../../../redux/fetchActions/legadoPage/transferApp';
import Wrapper from '../../../../../../../../../shared/components/Wrapper';

function SetCodLeg() {
  const transfersFilterState = useSelector(
    (reducer: IReducer) => reducer.transfersFilterApp
  );

  const dispatch = useDispatch();
  function setCod(event: React.FormEvent<any>) {
    const { value } = event.currentTarget;
    dispatch(setCodLeg(value));
  }

  return (
    <Wrapper.Default
      width="35%"
      style={{ padding: '0 5px 5px' }}
      isActive
      flexDirection="row"
      alignItens="start">
      <span
        style={{
          fontWeight: 700,
          lineHeight: '34px',
          minWidth: '125px',
        }}>
        Cod. Legado:
      </span>
      <Form.Control
        type="text"
        value={transfersFilterState.codLegado}
        onChange={(event) => setCod(event)}
      />
    </Wrapper.Default>
  );
}

export default SetCodLeg;
